var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_vm._l((_vm.modals),function(modal){return _c(modal.component,_vm._b({key:modal.guid,tag:"component"},'component',{ guid: modal.guid, ...modal.props },false))}),(_vm.isAuthenticated)?_c('Navbar'):_vm._e(),_c('v-main',{staticClass:"background"},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }